import { FC, useContext, useEffect } from "react";

import useFetch from "src/hooks/useFetch";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { LoaderContext } from "src/context/loaderContext";

import { DownloadZipResponseType } from "src/pages/dashboard/types";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseData, CaseDataResponse, DxCode, StepperModalProps } from "./types";
import { AuthContext } from "src/context/authContext";
import { ManufacturerSubHeaderProps } from "src/types/users";


const StepperModal: FC<StepperModalProps> = ({ onClick, caseId }): JSX.Element => {
  const { hideLoader, setLoader } = useContext(LoaderContext);
  const {userData,sub_header} = useContext(AuthContext);


  const { data: caseDetails } =
    useFetch<CaseDataResponse>(APIEndpoints.CASE_DETAIL_POPUP, { case_id: caseId })


  
  const {
    loading: downloadCaseLoader, data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
      //console.log("downloadCaseData...", downloadCaseData )
    if (downloadCaseData || downloadCaseError) {
      console.log({ downloadCaseData })
      if(downloadCaseData) {
        const { response ,report_name} = downloadCaseData;
        downloadPdfFile(response, report_name);
        hideLoader();
        onClick();
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadRequestFileByCaseId = () => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    downloadRequestForm({}, {}, { ref_id: caseId, type: 'request', ref_type: 'Case', skip_pi: true });
  };

  const downloadInsuranceFileByCaseId = (insuranceId: number) => {
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    downloadRequestForm({}, {}, { ref_id: insuranceId, type: 'investigation', ref_type: 'Insurance', skip_pi_investigation: true });
  };



  return (
    <div className={`modal fade show show show-modal`} id="typeModal" aria-labelledby="typeModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="text-center mb-0" style={{color: '#008853', fontSize:'1.875rem'}}>Case {caseId} Details
                
                  <button disabled={userData?.ref_type === "kam_lead" || userData?.ref_type === "kam" || downloadCaseLoader} id="request-link" className="btn btn-primary ms-2" onClick={downloadRequestFileByCaseId}>
                    <i className="bi bi-file-pdf-fill"></i> Request
                  </button>
                
            </h4>

            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClick}></button>
          </div>

          <div className="modal-body">
            {caseDetails && caseDetails.data && caseDetails.data.length > 0 &&
              caseDetails.data.map((item, index) => (
                <>
                  <div className={index !== 0 ? "d-none" : "card"}>
                    <div className="card-body py-0">
                      <div className="row justify-content-around">
                        <span className="col fw-bold">Dx Code(s):</span>
                        <span className="col">{(item as DxCode).dx_code}</span>
                      </div>
                    </div>
                  </div>
                  {index > 0 && (
                    <div className="card my-2" key={(item as CaseData).insurance_id || index}>
                      <div className="card-header">
                        <div className="row d-flex align-items-center">
                          <div className="col-md-3">
                            <b>Insurance Name:</b>
                          </div>
                          <div className="col-md-6">
                            {(item as CaseData).insurance_name || ""}
                          </div>
                         
                           {((sub_header as ManufacturerSubHeaderProps))?.forms_listing?.show_investigation_form === true && 
                           <div className="col-md-3 pr-0 text-end">
                            <button className="btn btn-primary ms-2" 
                              disabled={downloadCaseLoader}
                              onClick={() => downloadInsuranceFileByCaseId((item as CaseData).insurance_id || 0)}
                              style={{
                                paddingBlock: ".25rem",
                                paddingInline: ".5rem",
                                fontSize: ".95rem"
                              }}
                            >
                              <span className="fa fa-file-pdf"></span>{' '}Results
                            </button>
                          </div>}
                        </div>
                      </div>
    
                      <div className="card-body">
                        {/* <div className="row">
                          <div className="col-md-3">
                            <b>Product Coverage:</b>
                          </div>
                          <div className="col-md-3">
                            {kase.out_network_display ? kase.out_network_tab.product_coverage : kase.in_network_tab.product_coverage} %
                          </div>
                          <div className="col-md-3">
                            <b>Product Copay:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.product_copay : kase.in_network_tab.product_copay}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <b>Admin Coverage:</b>
                          </div>
                          <div className="col-md-3">
                            {kase.out_network_display ? kase.out_network_tab.admin_coverage : kase.in_network_tab.admin_coverage} %
                          </div>
                          <div className="col-md-3">
                            <b>Admin copay:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.admin_copay : kase.in_network_tab.admin_copay}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <b>Office Coverage:</b>
                          </div>
                          <div className="col-md-3">
                            {kase.out_network_display ? kase.out_network_tab.office_coverage : kase.in_network_tab.office_coverage} %
                          </div>
                          <div className="col-md-3">
                            <b>Office Copay:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.office_copay : kase.in_network_tab.office_copay}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <b>Deductible Met:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.deductible_met : kase.in_network_tab.deductible_met}
                          </div>
                          <div className="col-md-3">
                            <b>Deductible:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.deductible : kase.in_network_tab.deductible}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <b>Out of Pocket Met:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.out_of_pocket_met : kase.in_network_tab.out_of_pocket_met}
                          </div>
                          <div className="col-md-3">
                            <b>Out of Packet Max:</b>
                          </div>
                          <div className="col-md-3">
                            $ {kase.out_network_display ? kase.out_network_tab.out_of_pocket_max : kase.in_network_tab.out_of_pocket_max}
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-md-3">
                            <b>Rx Ben Notes:</b>
                          </div>
                          <div className="col-md-9">
                            {((item as CaseData).pharmacy_benefit && (item as CaseData).pharmacy_benefit?.rx_ben_notes) || ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ))
            }

              {/* ))
              : <h4 className="text-center fw-bold">{(caseDetails.data as string)}</h4>)
              : null
            } */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepperModal;
